import { computed, type Ref } from 'vue'
import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

/** Получаем объект со списком полей */
export const useLoadInventObjectSubType = (objectTypeId: Ref<number | null>, objectId: string) => {
  const http = useHttp()

  const queryKey = computed(() => ['load_invent_object_sub_type', objectTypeId])

  const url = computed(() => `/inventory/group/${objectId}/object-types/${objectTypeId.value}`)

  return useQuery({
    queryKey: queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: () => !!objectTypeId.value,
  })
}

/** Получаем список вариантов для IN_LIST */
export const useLoadInventObjectSubTypes = (objectTypeId: Ref<number | null>, objectId: string) => {
  const http = useHttp()

  const queryKey = computed(() => ['load_invent_object_sub_type', objectTypeId])

  const url = computed(
    () => `/inventory/objects/${objectId}/object-types/${objectTypeId.value}/subtypes`,
  )

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: () => !!objectTypeId.value,
  })
}

/** Получаем данные вычисляемого поля */
export const useLoadComputedFieldValue = (field: any, objectId: string) => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_computed_field_value', objectId, field.id],
    queryFn: () =>
      http.post(`/inventory/computed-field`, {
        list_invent_objects_id: objectId,
        computed_settings: field.computed_settings,
      }),
    retry: false,
    enabled: !!objectId,
  })
}
